import * as Sentry from "@sentry/react";

import { Router } from "@Router";

const DontSendErrors = [
  "Web Vitals",
  "Connection closed with an error",
  "Kullanıcı adı veya şifre hatalı",
  "Server returned hanshake error",
  "Cannot send data if the connection is not in the 'Connected' State.",
];

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.httpContextIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.replayCanvasIntegration(),
    Sentry.tanstackRouterBrowserTracingIntegration(Router),
    Sentry.browserApiErrorsIntegration({
      setTimeout: true,
      setInterval: true,
      requestAnimationFrame: true,
      XMLHttpRequest: true,
      eventTarget: true,
    }),
  ],
  ignoreErrors: DontSendErrors,
  sendDefaultPii: true,
  profilesSampleRate: 1.0,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    /^https:\/\/testapi\.thinkwork\.thinkwork\.com\/api/,
    /^https:\/\/crmapi\.thinksuite\.app\/api/,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
